var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { join } from "framework/helpers";
import { useif } from "framework/state/types";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { cls_justify_content_flex_end } from "framework/structural_components/hbox_vbox.css";
import * as React from "react";
import { cls_tooltip_base, cls_tooltip_content, cls_tooltip_content_box, cls_tooltip_content_visible } from "./tooltip.css";
export var Tooltip = function (props) {
    var _a = React.useState({ showContent: false, alignContentFromRighSide: false }), state = _a[0], setState = _a[1];
    var cls = join(cls_tooltip_base, props.className);
    var cls_content = join(cls_tooltip_content, useif(state.showContent, cls_tooltip_content_visible), useif(state.alignContentFromRighSide, cls_justify_content_flex_end), props.contentClassName);
    var mouseEnter = function (event) {
        var cursor_horizontal = event.clientX;
        var on_right_half = cursor_horizontal / window.innerWidth > 0.5;
        if (on_right_half) {
            setState({
                showContent: true,
                alignContentFromRighSide: true,
            });
        }
        else {
            setState({
                showContent: true,
                alignContentFromRighSide: false,
            });
        }
    };
    var mouseLeave = function () {
        setState(__assign(__assign({}, state), { showContent: false }));
    };
    return React.createElement(VBox, { className: cls, onMouseEnter: mouseEnter, onMouseLeave: mouseLeave },
        props.children,
        React.createElement(HBox, { className: cls_content }, props.content));
};
export var TooltipContentBox = function (props) {
    var cls = join(cls_tooltip_content_box, props.className);
    return props.children ? React.createElement(HBox, { className: cls }, props.children) : React.createElement(React.Fragment, null);
};
